import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import SecondaryActionButton from "components/__reusable/SecondaryActionButton";
import { CLASS_PATH } from "router/pathName";
import { NEW, TEACHER } from "config/keywords";
import useAppSelector from "hooks/useAppSelector";

const Menu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.user);
  const isTeacher = user?.role === TEACHER;

  return (
    <div className="w-full lg:flex lg:space-x-3 space-y-3 lg:space-y-0">
      <div className="w-full lg:w-1/4">
        <SecondaryActionButton
          label={`+ ${t("_class._add_class")}`}
          disabled={isTeacher}
          onClick={() => navigate(`${CLASS_PATH}/${NEW}`)}
        />
      </div>
    </div>
  );
};

export default Menu;
